import {  Grid, Stack, TextField, Typography } from '@mui/material';
import { FormikProps } from 'formik';
import { FormValuesB2B } from '../FormPageB2B';

const RepresentativePerson = ({ formik }: { formik: FormikProps<FormValuesB2B> }) => {
    const { values, handleChange, handleBlur, errors, touched } = formik;

    return (
        <Grid container spacing={6} alignItems="flex-start" direction={{ xs: 'column', sm: 'row' }} sx={{ marginTop: '60px' }}>
            <Grid size={{ xs: 12, sm: 12, md: 5 }} sx={{ height: 'auto' }}>
                <Typography variant="h6" sx={{ margin: 0, padding: '0px' }}>Przedstawiciel firmy</Typography>
            </Grid>
            <Grid size={{ xs: 12, sm: 12, md: 7 }} >
                <Stack>
                    <Grid container spacing={4} direction={{ xs: 'column', sm: 'row' }}>
                        <Grid size={{ xs: 12, sm: 4 }}>
                            <TextField
                                fullWidth
                                label="Imię"
                                name="representativePersonFirstName"
                                value={values.representativePersonFirstName}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={touched.representativePersonFirstName && Boolean(errors.representativePersonFirstName)}
                                helperText={touched.representativePersonFirstName && errors.representativePersonFirstName}
                            />
                        </Grid>
                        <Grid size={{ xs: 12, sm: 4 }}>
                        <TextField
                                fullWidth
                                label="Nazwisko"
                                name="representativePersonLastName"
                                value={values.representativePersonLastName}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={touched.representativePersonLastName && Boolean(errors.representativePersonLastName)}
                                helperText={touched.representativePersonLastName && errors.representativePersonLastName}
                            />
                        </Grid>
                        <Grid size={{ xs: 12, sm: 4 }}>
                        <TextField
                                fullWidth
                                label="Funkcja"
                                name="representativePersonPosition"
                                value={values.representativePersonPosition}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={touched.representativePersonPosition && Boolean(errors.representativePersonPosition)}
                                helperText={touched.representativePersonPosition && errors.representativePersonPosition}
                            />

                        </Grid>
                    </Grid>
                </Stack>
            </Grid>
        </Grid>
    );
};

export default RepresentativePerson;
